import request from '@/utils/request'

/**
 * @apiName 获取当前版本信息
 * @description 获取当前系统版本详情
 */
export function checkVersion() {
  return request({
    url: '/api/getCurrentVersion',
    method: 'POST',
  })
}
